export const initialGaragentorSystemState = {
    isMoving: false,
    direction: 'down',
    moveStartTimestamp: 0,
    position: 0,
    moveStartPosition: 0
};
